"use strict";

var _interopRequireDefault = require("/www/wwwroot/node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.constructor");
var _toConsumableArray2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _typeof2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find-index");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _request = _interopRequireDefault(require("@/utils/request"));
var _qrcode = _interopRequireDefault(require("qrcode"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  name: 'GoodForm',
  // props: {
  //   pk: Number,// 产品id
  //   isEdit: Boolean,//编辑还是新增
  //   is_day_nums: Boolean//是否一天多期
  // },
  data: function data() {
    return {
      qrImg: '',
      //存储当前商品的二维
      qrImg1: '',
      //存储当前商品的二维
      qrImgZ: '',
      //存储当前商品的二维码
      appId: 0,
      appId1: 0,
      cost_type_diy: 10,
      //自定义间隔天数
      errorarr: [],
      //错误提示信息
      listLoading: true,
      is_checkbill: false,
      // 账单已确认
      shou_cost_day1: 3,
      // 首付-首期扣款日
      newRuledata: [],
      //账单预览的数据源
      activeName: 'first',
      //默认显示的tab面板
      isEdit: false,
      //编辑还是新增
      is_day_nums: false,
      //是否一天多期
      ruleForm: {
        shop_name: '',
        //店铺选择
        name: '',
        //产品名称
        cost_type: 3,
        //扣费方式    1天 2月  3周  4自定义
        day_num: 1,
        //自定义天数
        order_mode: 1,
        //下单方式
        active: 1,
        //上架状态
        cost_money: '',
        //成本金额，更改为预购订单总金额 （通过扣款规则计算自动生成）
        deposit: 0,
        //押金（原首付款）
        order_type: 2,
        //下单类型
        goods_cate: '',
        //产品分类
        shou_money: '30000',
        //首付扣款总额
        shou_cost_num: 10,
        //首付扣款期数
        shou_cost_day: 2,
        //需扣款期数
        money: '',
        //扣款总额，更改为首付扣款总额
        cost_num: 10,
        //扣款期数，更改为首付扣款期数
        cost_rule: '',
        //扣款规则

        q_cost_day: 0,
        //提前扣款天数
        d_cost_type: 0,
        //到期买断开关
        d_cost_money: 0,
        //到期买断价
        remark: '',
        //备注提示信息
        parameter: '',
        //待选参数名称
        parameter_value: '',
        //产品待选参数
        // 以下为新增字段
        brand: '',
        //产品品牌
        model: '',
        //型号
        main_class: '',
        //一级分类
        sub_class: '',
        //二级分类
        good_img: '' //产品图片
      },
      labelWidth: '180px',
      rules: {
        name: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }, {
          min: 2,
          message: '最少2个字符',
          trigger: 'blur'
        }, {
          validator: this.validateName,
          trigger: 'blur'
        }],
        // good_img: [
        //     { required: true, message: '请上传产品图片', trigger: 'change' }
        // ],
        cost_money: [{
          required: true,
          message: '请输入成本金额',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error('请输入成本金额'));
            } else if (isNaN(value) || parseInt(value, 10) < 1) {
              callback(new Error('最少1元'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        money: [{
          required: true,
          message: '请输入扣款金额',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error('请输入扣款金额'));
            } else if (isNaN(value) || parseInt(value, 10) < 1) {
              callback(new Error('最少1元'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        shou_money: [{
          required: true,
          message: '请输入首付扣款总额',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error('请输入首付扣款总额'));
            } else if (isNaN(value) || parseInt(value, 10) > 30000) {
              callback(new Error('最多3万'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      currentCate: '',
      //产品分类
      options: [{
        value: '3C',
        label: '3C办公',
        children: [{
          value: '3c_mobile',
          label: '手机'
        }, {
          value: '3c_pc',
          label: '电脑'
        }, {
          value: '3c_camera',
          label: '摄影'
        }, {
          value: '3c_game_console',
          label: '游戏机'
        }, {
          value: '3c_office',
          label: '办公设备'
        }, {
          value: '3c_other',
          label: '3C-其他'
        }]
      }, {
        value: 'IOT',
        label: 'IOT',
        children: [{
          value: 'iot_auto_container',
          label: '售卖柜'
        }, {
          value: 'iot_stage',
          label: '驿站'
        }, {
          value: 'iot_other',
          label: 'IOT-其他'
        }]
      }, {
        value: 'NE',
        label: '新能源',
        children: [{
          value: 'ne_battery',
          label: '电池'
        }, {
          value: 'ne_car',
          label: '汽车'
        }, {
          value: 'ne_electric_car_logistic',
          label: '快递配送电动两轮车'
        }, {
          value: 'ne_electric_car_community',
          label: '城市共享电动两轮'
        }, {
          value: 'ne_other',
          label: '新能源-其他'
        }]
      }, {
        value: 'GENERAL',
        label: '泛行业',
        children: [{
          value: 'general_furniture',
          label: '家具'
        }, {
          value: 'general_tv',
          label: '家电'
        }, {
          value: 'general_house',
          label: '房屋'
        }, {
          value: 'general_decoration',
          label: '二手奢侈品或工艺品'
        }, {
          value: 'general_other',
          label: '泛其他'
        }]
      }, {
        value: 'EDUCATION',
        label: '教奇培训',
        children: [{
          value: 'education_vocational_training',
          label: '职业教培'
        }, {
          value: 'quality_education',
          label: '素质教育'
        }]
      }, {
        value: 'PETS',
        label: '宠物',
        children: [{
          value: 'adoption_installment',
          label: '颔养分期'
        }]
      }],
      activeZH: '上架',
      optionsvalue: [],
      selectedFile: null,
      imageUrl: null,
      flag: false,
      // 修改图片的标志
      costRuledata: [],
      //可视化扣款规则
      ruledialogVisible: false,
      // 控制规格弹窗是否显示
      ruleformdata: {
        date: 1,
        money: ''
      },
      costRuledata1: [],
      //补充后的扣款规则
      currentRowRule: '',
      //记录用户修改的当前行内容
      day45: '',
      //45天后的日期
      q_money: 2,
      //扣款前日测试划扣金额，0时为不进行设置
      dialogFormVisible: false,
      dialogFormVisible1: false,
      split_date: '',
      split_money: 0,
      is_customer_pay: true,
      bind_mobile: ''
    };
  },
  created: function created() {
    this.getCharge();
    // 从地址栏中获取路径
    this.pk = this.$route.query.pk;

    // 新增不请求
    if (this.pk) {
      this.getList();
      this.isEdit = true;
      this.getQRCode(this.pk);
    }
    var today = new Date();
    var futureDate = new Date(today);
    futureDate.setDate(today.getDate() + 30);
    this.day45 = futureDate.toISOString().split('T')[0];
  },
  computed: {
    // 扣款规则_字符串——done
    // costRule() {
    //     // 将cost_rule数组的内容提取出来，变成字符串
    //     const ruleStr = JSON.parse(this.ruleForm.cost_rule)
    //     if (Array.isArray(ruleStr)) {
    //         return ruleStr.join(',');
    //     }
    //     return ruleStr
    // },
    // 待选参数_字符串——done
    parmaValue: function parmaValue() {
      // 将parameter_value数组的内容提取出来，变成字符串
      var ruleStr = JSON.parse(this.ruleForm.parameter_value);
      if (Array.isArray(ruleStr)) {
        return ruleStr.join(',');
      }
      return ruleStr.trim();
    }
  },
  // 监视器
  watch: {
    // 监听 newRuledata 的变化
    newRuledata: {
      handler: function handler(newVal) {
        // console.log(newVal)
        newVal.map(function (item) {
          // console.log(item.splitmoney)
          if (item.splitmoney.length > 0) {
            console.log(item);
            item.splitmoney.map(function (arr) {
              // console.log(arr)
              // 使用正则表达式检查 arr.date 是否为 YYYY-MM-DD 格式
              // const regex = /^\d{4}-\d{2}-\d{2}$/;
              // if (!regex.test(arr.date)) {
              //   arr.date = this.formatDatefn(item.date);
              // } else {
              //   arr.date = item.date
              // }
              arr.date = item.date;
            });
          }
        });
        this.generateTotal(newVal);
        // this.computedRule(newVal);

        this.computedRule();
      },
      deep: true // 深度监听，确保对象内部的变化也能被检测到
    }
  },
  methods: {
    // 根据id生成二维码
    getQRCode: function () {
      var _getQRCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var str, str2, str1;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 生成二维码图片
              // 获取当前路由中得id
              // const id = this.$route.query.pk
              str = "https://user.jiujiuqian.cn/#/pages/mine/addOrder?id=".concat(id, "&type=0");
              str2 = "https://user.jiujiuqian.cn/#/pages/mine/addOrder?id=".concat(id, "&type=1");
              _context.next = 4;
              return _qrcode.default.toDataURL(str);
            case 4:
              this.qrImg = _context.sent;
              _context.next = 7;
              return _qrcode.default.toDataURL(str2);
            case 7:
              this.qrImg1 = _context.sent;
              //   const str = `alipays://platformapi/startapp?appId=${this.appId}&page=pages/mine/addOrder?id=${id}`
              //   console.log(str)
              //   this.qrImg = await QRCode.toDataURL(str)
              str1 = "alipays://platformapi/startapp?appId=".concat(this.appId1, "&page=pages/mine/addOrder?id=").concat(id);
              console.log(str1);
              _context.next = 12;
              return _qrcode.default.toDataURL(str1);
            case 12:
              this.qrImgZ = _context.sent;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getQRCode(_x) {
        return _getQRCode.apply(this, arguments);
      }
      return getQRCode;
    }(),
    // 手动拆单方法
    validateAndSetSplitnum: function validateAndSetSplitnum(item) {
      if (this.ruleForm.active != '拒绝' && this.isEdit == true) {
        this.$message.error('当前商品处于非拒绝状态，不可修改');
        item.tempSplitnum = '';
        return;
      }
      if (item.tempSplitnum < 2) {
        this.$message.error('最少拆2单');
        return;
      }
      if (item.tempSplitnum > 10) {
        this.$message.error('最多拆10单');
        return;
      }

      // 更新 item.splitnum 并重新计算拆单数据
      item.splitnum = item.tempSplitnum;
      this.splitmoneyByDate(item, item.tempSplitnum);
    },
    // 取消拆单
    cancelsplitmoneyByDate: function cancelsplitmoneyByDate(item) {
      // if(this.is_checkbill){
      //   this.$message.error('禁止修改')

      //   return;
      // }

      // 3. 根据 record 将 newRuledata 中对应 record 的 splitmoney 替换成新组成的数组，splitnum 替换传入的 num
      var recordIndex = this.newRuledata.findIndex(function (recordItem) {
        return recordItem.record === item.record;
      });
      if (recordIndex !== -1) {
        this.newRuledata[recordIndex].splitmoney = [];
        this.newRuledata[recordIndex].splitnum = 0;
      }
      this.tempSplitnum = 0;
    },
    // 单期拆单方法，默认是2期
    splitmoneyByDate: function splitmoneyByDate(item, num) {
      item.isSplitVisibel = true;
      if (this.ruleForm.active != '拒绝' && this.isEdit == true) {
        this.$message.error('当前商品处于非拒绝状态，不可修改');
        // item.splitnum = ''
        return;
      }

      // if (num < 2) {
      //   this.$message.error('最少拆2单');
      //   return;
      // }

      // 强制转换为数字
      item.money = parseFloat(item.money);
      num = parseFloat(num);

      // 如果item.money  小于 num, 则提示错误并返回
      if (item.money < num) {
        console.log(item.money, num);
        this.$message.error('金额小于' + num + '元，不能拆分');
        return;
      }

      // 1. 将 item.money 按照传入的 num 平分
      var parts = this.splitIntoTenParts(item.money, num);

      // 2. 生成拆分后的数组，每个拆分项包含 money 和 date
      var splitMoneyArray = parts.map(function (money, index) {
        return {
          money: money,
          date: item.date // 所有拆分项的日期都相同
        };
      });

      // 3. 根据 record 将 newRuledata 中对应 record 的 splitmoney 替换成新组成的数组，splitnum 替换传入的 num
      var recordIndex = this.newRuledata.findIndex(function (recordItem) {
        return recordItem.record === item.record;
      });
      if (recordIndex !== -1) {
        this.newRuledata[recordIndex].splitmoney = splitMoneyArray;
        this.newRuledata[recordIndex].splitnum = num;
      }

      // 重新计算预购订单总期数和扣款规则
      this.generateTotal(this.newRuledata);
      this.computedRule();
    },
    // 根据用户输入的金额，期数和扣款天数进行自动拆单
    generatePreviewBill: function generatePreviewBill() {
      var _this = this;
      if (this.ruleForm.shou_money > 30000) {
        this.$message.error('首付扣款金额最多3万');
        return;
      }

      // 先解冻
      this.is_checkbill = false;

      // 金额必须大于0
      if (this.ruleForm.shou_money <= 0) {
        this.$message.error('首付扣款金额必须大于0');
        return;
      }

      // console.log(this.ruleForm.shou_money)

      // 必须能平分，不能有小数
      if (Number(this.ruleForm.shou_money) < Number(this.ruleForm.shou_cost_day)) {
        this.$message.error("\u9996\u4ED8\u6263\u6B3E\u91D1\u989D\u5C0F\u4E8E".concat(this.ruleForm.shou_cost_day, "\u5143\uFF0C\u4E0D\u53EF\u5206\u671F"));
        return;
      }
      if (this.q_money > 0 && Number(this.ruleForm.shou_cost_day) > 30) {
        this.$message.error("\u9700\u6263\u6B3E\u671F\u6570\u4E0D\u80FD\u5927\u4E8E30\u671F");
        return;
      }

      // 验证 shou_cost_day 是否大于等于 1
      if (this.shou_cost_day1 < 3) {
        this.$message.error('首付-首期扣款日必须大于等于3天，1天含当天');
        this.shou_cost_day1 = 3; // 将值重置为1
        return;
      }

      // 验证 shou_cost_day 是否大于等于 1
      if (this.ruleForm.cost_type == 4 && this.cost_type_diy < 3) {
        this.$message.error('自定义扣款周期不能小于3天');
        this.cost_type_diy = 3; // 将值重置为1
        return;
      }
      // 将首付扣款总额分成首付扣款期数的分数
      var parts = this.splitIntoTenParts(this.ruleForm.shou_money, this.ruleForm.shou_cost_day);

      // 假设当前日期为 today
      var today = new Date();
      // 将 this.shou_cost_day1 转换为数值类型
      var shouCostDay = Number(this.shou_cost_day1);

      // 根据 shou_cost_day 设置起始日期
      var startDate = new Date(today);
      startDate.setDate(today.getDate() + shouCostDay - 1);

      // 根据 ruleForm.cost_type 设置间隔天数
      var daysToAdd;
      switch (this.ruleForm.cost_type) {
        case 1:
          // 天
          daysToAdd = 1;
          break;
        case 3:
          // 周
          daysToAdd = 7;
          break;
        case 2:
          // 月
          daysToAdd = 30;
          break;
        case 4:
          // 自定义天数
          daysToAdd = this.cost_type_diy;
          break;
        default:
          daysToAdd = 7;
        // 默认情况下按天计算
      }

      // 结果数组
      var resultArray = [];
      parts.map(function (money, index) {
        // 计算延后日期
        var newDate = new Date(startDate);
        if (_this.q_money > 0) {
          var newDateQ = new Date(startDate);
          newDateQ.setDate(startDate.getDate() + daysToAdd * index - 1);
          var yearQ = newDateQ.getFullYear();
          var monthQ = String(newDateQ.getMonth() + 1).padStart(2, '0'); // 确保月份从 1 开始
          var dayQ = String(newDateQ.getDate()).padStart(2, '0');
          var formattedDateQ = "".concat(yearQ, "-").concat(monthQ, "-").concat(dayQ);
          resultArray.push({
            record: index * 2 + 1,
            money: _this.q_money,
            date: formattedDateQ,
            splitmoney: [],
            splitnum: 0,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: true,
            // 允许拆单
            isSplitVisibel: false,
            is_q: true
          });
          newDate.setDate(startDate.getDate() + daysToAdd * index);
          // 格式化日期为 YYYY-MM-DD 格式
          var year = newDate.getFullYear();
          var month = String(newDate.getMonth() + 1).padStart(2, '0'); // 确保月份从 1 开始
          var day = String(newDate.getDate()).padStart(2, '0');
          var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
          resultArray.push({
            record: index * 2 + 2,
            money: money - _this.q_money,
            date: formattedDate,
            splitmoney: [],
            splitnum: 0,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: true,
            // 允许拆单
            isSplitVisibel: false,
            is_q: false,
            item_date: ""
          });
        } else {
          newDate.setDate(startDate.getDate() + daysToAdd * index);
          // 格式化日期为 YYYY-MM-DD 格式
          var _year = newDate.getFullYear();
          var _month = String(newDate.getMonth() + 1).padStart(2, '0'); // 确保月份从 1 开始
          var _day = String(newDate.getDate()).padStart(2, '0');
          var _formattedDate = "".concat(_year, "-").concat(_month, "-").concat(_day);
          resultArray.push({
            record: index + 1,
            money: money,
            date: _formattedDate,
            splitmoney: [],
            splitnum: 0,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: true,
            // 允许拆单
            isSplitVisibel: false,
            is_q: false
          });
        }
      });
      // let resultArray = parts.map((money, index) => {
      //   // 计算延后日期
      //   let newDate = new Date(startDate);
      //   newDate.setDate(startDate.getDate() + (daysToAdd * index));

      //   // 格式化日期为 YYYY-MM-DD 格式
      //   let year = newDate.getFullYear();
      //   let month = String(newDate.getMonth() + 1).padStart(2, '0'); // 确保月份从 1 开始
      //   let day = String(newDate.getDate()).padStart(2, '0');
      //   let formattedDate = `${year}-${month}-${day}`;

      //   return {
      //     record: index + 1,
      //     money: money,
      //     date: formattedDate,
      //     splitmoney: [],
      //     splitnum: 0,
      //     tempSplitnum: null, // 添加 tempSplitnum 属性
      //     is_split: true,// 允许拆单
      //     isSplitVisibel: false
      //   };
      // });

      console.log("resultArray", resultArray);
      this.newRuledata = resultArray;
    },
    // 页头--返回上级页面
    goBack: function goBack() {
      // 返回列表页
      //   this.$router.push({ name: 'goodList' })
      this.$router.push({
        name: 'goodList',
        query: {
          page: this.$route.query.page
        }
      });
    },
    // 获取是否可一天多期
    getCharge: function getCharge() {
      var _this2 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (res) {
        if (res.data) {
          // this.dialogFormVisible = true;
          _this2.is_day_nums = res.data.is_day_nums;
          if (res.data.is_bear || res.data.is_contract || res.data.is_hand) {
            _this2.is_customer_pay = false;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 将数值平分成指定数量——用于拆单计算
    splitIntoTenParts: function splitIntoTenParts(totalAmount, num) {
      var parts = [];
      var baseValue = Math.floor(totalAmount / num);
      var remainder = totalAmount % num;
      for (var i = 0; i < num; i++) {
        if (i < remainder) {
          parts.push(baseValue + 1);
        } else {
          parts.push(baseValue);
        }
      }
      return parts;
    },
    // 自动补全到45天扣款规则
    completeRule: function completeRule() {
      this.errorarr = [];
      var errors = [];
      var isValid = true;
      if (this.newRuledata[0].splitnum < 2) {
        errors.push('第一期拆单期数最少2期');
      }

      // 1.将所有子账单相加是否等于当期扣款金额
      this.newRuledata.forEach(function (item) {
        if (item.splitmoney.length > 0) {
          var onemoney = 0; // 每次循环时重置 onemoney
          item.splitmoney.forEach(function (item1) {
            onemoney += parseFloat(item1.money || 0);
          });
          if (onemoney !== parseFloat(item.money || 0)) {
            errors.push("\u9884\u89C8\u8D26\u5355\u4E2D\u7684".concat(item.date, "\u7684\u6263\u6B3E\u91D1\u989D\u548C\u62C6\u5355\u6263\u6B3E\u91D1\u989D\u603B\u548C\u4E0D\u4E00\u81F4"));
            isValid = false;
          }
        }
      });

      // 2.校验日期，日期必须递增，不能有相等的情况存在
      for (var i = 0; i < this.newRuledata.length - 1; i++) {
        if (new Date(this.newRuledata[i].date) >= new Date(this.newRuledata[i + 1].date)) {
          errors.push("\u9884\u89C8\u8D26\u5355\u4E2D\u7684\u7B2C".concat(i + 2, " \u671F\u6263\u6B3E\u65E5\u671F\u5FC5\u987B\u9012\u589E\uFF01"));
          isValid = false;
        }
      }

      // 计算当前剩余金额
      var sum = this.newRuledata.reduce(function (accumulator, item) {
        return accumulator + parseFloat(item.money);
      }, 0);
      if (this.ruleForm.shou_money <= sum) {
        errors.push('请预留补充金额');
      }
      if (errors.length > 0) {
        this.errorarr = errors;
        return;
      }

      // 计算剩余金额
      var remainingAmount = this.ruleForm.shou_money - sum;

      // 获取拆分金额-固定值
      var splitAmount = this.newRuledata[0].splitmoney[0].money ? parseFloat(this.newRuledata[0].splitmoney[0].money) : parseFloat(this.newRuledata[0].money);
      var numSplits = Math.floor(remainingAmount / splitAmount);
      if (numSplits < 1) {
        errors.push('剩余金额比拆单金额少');
      }
      if (errors.length > 0) {
        this.errorarr = errors;
        return;
      }

      // 实时获取当前日期往后推45天的日期formattedDate
      var today = new Date();
      var futureDate = new Date(today);
      futureDate.setDate(today.getDate() + 45);
      var formattedDate = futureDate.toISOString().split('T')[0];

      // 确保 this.newRuledata[this.newRuledata.length - 1].date 的格式为 YYYY-MM-DD
      var lastDate = this.newRuledata[this.newRuledata.length - 1].date; // 商家账单的最后一个日期
      if ((0, _typeof2.default)(lastDate) === 'object' && lastDate instanceof Date) {
        // 如果 lastDate 是 Date 对象，则将其转换为 YYYY-MM-DD 格式
        lastDate = this.formatDatefn(lastDate);
      }
      if (lastDate >= formattedDate) {
        this.$message.error('45天扣款规则已自动补全，请勿重复操作');
        return;
      }

      // 最后一项的日期作为补充的初始日期
      var initialDate = new Date(lastDate);
      // 计算第一项和第二项的日期差值（天数）
      console.log('执行了2');
      var firstDate = new Date(this.newRuledata[0].date);
      var secondDate = new Date(this.newRuledata[1].date);
      var daysDiffs = (secondDate - firstDate) / (1000 * 60 * 60 * 24);
      console.log(daysDiffs, 'daysDiffs', numSplits);
      var completeDate = [];

      // 从初始日期开始，循环生成新的扣款规则项
      var currentDate = new Date(initialDate);
      var record = this.newRuledata[this.newRuledata.length - 1].record + 1;
      var count = 1; // 计数器，用于控制推送的次数

      while (count <= numSplits) {
        currentDate = new Date(currentDate); // 创建一个新的日期对象以避免修改原始日期对象
        currentDate.setDate(currentDate.getDate() + daysDiffs);

        // 格式化日期为 YYYY-MM-DD 格式
        var formattedCurrentDate = this.formatDatefn(currentDate);
        completeDate.push({
          record: record,
          money: splitAmount,
          // 金额直接用拆分后的金额
          date: formattedCurrentDate,
          splitmoney: [],
          splitnum: 0,
          tempSplitnum: null,
          // 添加 tempSplitnum 属性
          is_split: false,
          // 允许拆单
          isSplitVisibel: false
        });
        if (formattedCurrentDate >= formattedDate) {
          break;
        }
        record++;
        count++; // 增加计数器
      }

      // 检查生成的最后一个日期是否大于等于 formattedDate
      if (completeDate[completeDate.length - 1].date > formattedDate) {
        // 如果是，则按照这个逻辑走
        this.newRuledata = [].concat((0, _toConsumableArray2.default)(this.newRuledata), (0, _toConsumableArray2.default)(completeDate));
      } else {
        // 计算最后一项的日期和45天后的日期之间的差值（天数）
        var daysDifference = (futureDate - initialDate) / (1000 * 60 * 60 * 24);
        // 将差值除以3并向上取整
        daysDiffs = Math.ceil(daysDifference / numSplits);
        completeDate = [];
        currentDate = new Date(initialDate);
        record = this.newRuledata[this.newRuledata.length - 1].record + 1;
        while (true) {
          currentDate = new Date(currentDate); // 创建一个新的日期对象以避免修改原始日期对象
          currentDate.setDate(currentDate.getDate() + daysDiffs);

          // 格式化日期为 YYYY-MM-DD 格式
          var _formattedCurrentDate = this.formatDatefn(currentDate);
          completeDate.push({
            record: record,
            money: splitAmount,
            // 金额直接用拆分后的金额
            date: _formattedCurrentDate,
            splitmoney: [],
            splitnum: 0,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: false,
            // 允许拆单
            isSplitVisibel: false
          });
          if (_formattedCurrentDate >= formattedDate) {
            break;
          }
          record++;
        }
        this.newRuledata = [].concat((0, _toConsumableArray2.default)(this.newRuledata), (0, _toConsumableArray2.default)(completeDate));
      }

      // 异常处理
      // 1.如果处理后的newRuledata,所有金额相加超出首付扣款金额,就把最后一项减去多出的值
      var newsum = this.newRuledata.reduce(function (accumulator, item) {
        return accumulator + parseFloat(item.money);
      }, 0);
      if (newsum > this.ruleForm.shou_money) {
        // console.log('多')
        // 计算多出的金额
        var excessAmount = newsum - this.ruleForm.shou_money;
        // 更新最后一项的金额
        this.newRuledata[this.newRuledata.length - 1].money -= excessAmount;
      }
      if (newsum < this.ruleForm.shou_money) {
        // 计算多出的金额
        var _excessAmount = this.ruleForm.shou_money - newsum;

        // console.log(excessAmount)

        // 更新最后一项的金额
        this.newRuledata[this.newRuledata.length - 1].money = this.newRuledata[this.newRuledata.length - 1].money + _excessAmount;
      }

      // this.newRuledata = [...this.newRuledata, ...completeDate];
      this.is_checkbill = true;
      console.log(this.newRuledata, '最新数据');
      this.generateTotal(this.newRuledata);
      this.computedRule();
    },
    // 生成预购订单的总金额和总期数
    generateTotal: function generateTotal(data) {
      // 验证金额和日期
      if (!this.validateAmountAndDate(data, false)) {
        return; // 如果验证失败，直接返回，不继续执行
      }

      // 根据costRuledata数据计算扣款期数和金额
      var totalMoney = 0;
      var totalPeriods = 0;

      // 遍历data数组
      data.forEach(function (item) {
        // console.log(item)
        // 确保 item.money 是字符串
        // 否则直接转换为数字并累加
        var money = parseFloat(item.money);
        totalMoney += money;
        if (Number(item.splitnum) > 0) {
          totalPeriods += Number(item.splitnum);
        } else {
          totalPeriods += 1;
        }
      });
      this.ruleForm.cost_num = totalPeriods;
      this.ruleForm.money = totalMoney;
      this.ruleForm.shou_cost_num = totalPeriods;
      return {
        totalMoney: totalMoney,
        totalPeriods: totalPeriods
      }; // 返回对象
    },
    // 补全扣款规则——传递给后端
    computedRule: function computedRule() {
      var newarr = [];

      // 根据newRuledata数组生成一个完整的数组
      // 遍历newRuledata
      // console.log(this.newRuledata.length)

      this.newRuledata.forEach(function (item) {
        if (item.splitnum > 0) {
          newarr.push({
            date: item.date,
            money: item.splitmoney
          });
        } else {
          newarr.push({
            date: item.date,
            money: item.money
          });
        }
      });

      // console.log('newarr', newarr);

      var newarr1 = [];

      // 获取当前日期，只取年月日部分
      var today = new Date();
      today.setHours(0, 0, 0, 0); // 设置时间为00:00:00.000

      // 遍历newarr，如果money是数组，则将数组中每一项的money取出来，用竖线进行拼接，复制给money
      // 获取当前日期，然后计算每一项的date与当前日期的差值，然后加1，作为index
      // 将新获取的money和index一起push进newarr1中
      newarr.forEach(function (item) {
        // console.log('item.money', item.money);

        // 检查 item.date 是否存在且为有效的日期字符串
        var date = new Date(item.date);
        date.setHours(0, 0, 0, 0); // 设置时间为00:00:00.000

        // 计算日期差值（天数）
        var diffTime = Math.abs(date - today);
        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 计算日期差值并加1

        // console.log('diffDays', diffDays, diffTime);

        if (Array.isArray(item.money)) {
          var result = item.money.map(function (item) {
            return item.money;
          }).join('|');
          item.money = result;
        }
        newarr1.push({
          date: diffDays + 1,
          // 加1得到新的date
          money: item.money
        });
      });
      // console.log('newarr1', newarr1);

      var newresult = this.completeArray(newarr1);

      // console.log('newresult', newresult);

      // 将newresult的每一项的money取出来用逗号拼接成字符串
      var moneyString = newresult.map(function (item) {
        return item.money;
      }).join(',');
      // 更新 ruleForm.cost_rule
      this.ruleForm.cost_rule = moneyString;
    },
    // 补全数组，从当前日期到超过90天
    completeArray: function completeArray(arr) {
      var result = [];
      var currentDate = 1;
      var index = 0;
      while (currentDate <= arr[arr.length - 1].date) {
        if (index < arr.length && arr[index].date === currentDate) {
          result.push({
            date: currentDate,
            money: arr[index].money
          });
          index++;
        } else {
          result.push({
            date: currentDate,
            money: 0
          });
        }
        currentDate++;
      }
      return result;
    },
    handleFileChange: function handleFileChange(event) {
      this.flag = true;
      // 获取用户选择的图片
      this.selectedFile = event.target.files[0];

      // 图片格式 只能是 JPG/JPEG/PNG 格式!
      var isJPG = this.selectedFile.type === 'image/jpeg'; // 检查 JPG 格式
      // 图片大小 不能超过 5MB
      var isLt5M = this.selectedFile.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JPEG 格式!');
        return;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return;
      }

      // 在用户界面中显示用户选择的图片预览。
      console.log(this.selectedFile, 'selectedFile');
      this.imageUrl = URL.createObjectURL(this.selectedFile);
      console.log(this.imageUrl, 'imageUrl');
    },
    // 产品名称不能含有敏感词——done
    validateName: function validateName(rule, value, callback) {
      var sensitiveWords = ['e卡', '易卡', 'E卡', '一卡', 'e 卡', '易 卡', 'E 卡', '一 卡', 'e_卡', '易_卡', 'E_卡', '一_卡', '京东', '京 东', '京东E卡', '京东 E卡', '京东_E卡', '京东e卡', '京东_e卡', '京东 e卡', '东E'];
      // const sensitiveWords = ['京', '东', '卡', 'e', '易', '一'];
      // if (sensitiveWords.includes(value)) {
      //     callback(new Error('产品名不可用，请重新修改'));
      // } else {
      //     callback();
      // }
      // 创建一个正则表达式，用于匹配任何包含敏感词的字符串
      var sensitiveRegex = new RegExp(sensitiveWords.map(function (word) {
        return word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('|'), 'i');
      if (sensitiveRegex.test(value)) {
        callback(new Error('产品名不可用，请重新修改'));
        // 清空输入
        this.ruleForm.name = '';
        return;
      } else {
        callback();
      }
    },
    // 当下单类型改变时，更新规则(新增扣款规则，扣款期数，扣款总额的相关逻辑校验)——done
    updateRules: function updateRules() {
      if (this.ruleForm.order_type === 2) {
        if (this.is_day_nums) {
          // 扣款期数最少为7期
          this.$set(this.rules, 'cost_num', [{
            required: true,
            message: '请输入扣款期数',
            trigger: 'blur'
          }, {
            validator: function validator(rule, value, callback) {
              if (!value) {
                callback(new Error('请输入扣款期数'));
              } else if (isNaN(value) || parseInt(value, 10) < 2 || parseInt(value, 10) > 52) {
                callback(new Error('最少2期,最多51期'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }]);
          this.$set(this.rules, 'cost_rule', [{
            required: true,
            message: '请通过【添加扣款规则】录入信息，将自动生成此项内容',
            trigger: 'blur'
          },
          //  1.输入英文逗号,管道符，任意数字
          {
            pattern: /^[0-9,|]+$/,
            message: '扣费规则仅可输入数字，英文逗号，竖线',
            trigger: 'blur'
          },
          //  扣款规则的每个值最少为1
          {
            validator: this.validateCostRuleValue,
            trigger: 'blur'
          },
          //  2.扣款规则数值总和 = 扣款总额
          {
            validator: this.validateCostMoney,
            trigger: 'blur'
          },
          //  3.扣款期数等于扣款规则数
          {
            validator: this.validateCostRule,
            trigger: 'blur'
          }]);
        } else {
          // 扣款期数最少为7期
          this.$set(this.rules, 'cost_num', [{
            required: true,
            message: '请输入扣款期数',
            trigger: 'blur'
          }, {
            validator: function validator(rule, value, callback) {
              if (!value) {
                callback(new Error('请输入扣款期数'));
              } else if (isNaN(value) || parseInt(value, 10) < 2 || parseInt(value, 10) > 52) {
                callback(new Error('最少2期,最多51期'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }]);
          this.$set(this.rules, 'cost_rule', [{
            required: true,
            message: '请通过【添加扣款规则】录入信息，将自动生成此项内容',
            trigger: 'blur'
          },
          //  1.输入英文逗号和任意数字
          {
            pattern: /^[0-9,]+$/,
            message: '扣费规则仅可输入数字和英文逗号',
            trigger: 'blur'
          },
          //  扣款规则的每个值最少为1
          {
            validator: this.validateCostRuleValue,
            trigger: 'blur'
          },
          //  2.扣款规则数值总和 = 扣款总额
          {
            validator: this.validateCostMoney,
            trigger: 'blur'
          },
          //  3.扣款期数等于扣款规则数
          {
            validator: this.validateCostRule,
            trigger: 'blur'
          }]);
        }
      } else {
        this.$set(this.rules, 'cost_num', []);
        this.$set(this.rules, 'cost_rule', []);
      }
      this.$refs.ruleForm.clearValidate(['cost_num']);
      this.$refs.ruleForm.clearValidate(['cost_rule']);
    },
    // 扣款规则的每个值最少为1——done
    validateCostRuleValue: function validateCostRuleValue(rule, value, callback) {
      // value为扣款规则
      // 否则按照原逻辑处理
      // 使用英文逗号或竖线

      var arr = value.split(/[,\|]/).map(Number);
      if (arr.every(function (item) {
        return item >= 0;
      })) {
        callback();
      } else {
        callback(new Error('扣款规则金额最少为0元'));
      }
    },
    // 扣款规则数值相加不等于扣款总额——done
    validateCostMoney: function validateCostMoney(rule, value, callback) {
      // value为扣款规则
      // 否则按照原逻辑处理
      var sum = value.split(/[,\|]/).map(Number).reduce(function (acc, curr) {
        return acc + curr;
      }, 0);
      if (sum == this.ruleForm.money) {
        callback();
      } else {
        callback(new Error('扣款规则数值总和与扣款总额不一致'));
      }
    },
    // 扣款规则数和扣款期数不一致——done
    validateCostRule: function validateCostRule(rule, value, callback) {
      var num = 0;
      value.split(/[,\|]/).map(function (item) {
        if (item > 0) {
          num++;
        }
      });
      console.log(num);
      // value为扣款规则
      // 扣款期数等于扣款规则数
      if (num != this.ruleForm.cost_num) {
        callback(new Error('扣款期数与扣款规则数不一致'));
      } else {
        callback();
      }
    },
    // 提交表单
    submitForm: function submitForm(formName) {
      var _this3 = this;
      if (!this.validateAmountAndDate(this.newRuledata, true)) {
        this.$message.error('预览账单存在错误，请查看报错信息');
        return; // 如果验证失败，直接返回，不继续执行
      }

      // this.updateRules()
      // 如果有报错提示修复后重试
      if (this.errorarr.length > 0) {
        this.$message.error('预览账单存在错误，请查看报错信息');
        return;
      }

      // 检查 costRuledata 的最后一项的 date 是否满足条件
      if (this.newRuledata.length > 0) {
        var lastDate = this.newRuledata[this.newRuledata.length - 1].date;
        // 实时获取当前日期往后推90天的日期formattedDate
        var today = new Date();
        var futureDate = new Date(today);
        futureDate.setDate(today.getDate() + 30);
        var formattedDate = futureDate.toISOString().split('T')[0];
        if (lastDate < formattedDate) {
          this.$message.error('账单周期需至少30天，请修改后重试');
          return;
        }
      }
      if (!this.ruleForm.money) {
        this.$message.error('预购订单金额不能为空，请检查预览账单是否正确');
        return;
      }
      if (this.ruleForm.cost_num > 60) {
        this.$message.error('预购订单期数不得大于60，请修改后重试');
        return;
      }
      if (!this.selectedFile) {
        alert('请上传图片!!');
        return;
      }
      this.ruleForm.good_img = this.selectedFile;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this3.ruleForm);
          if (_this3.isEdit) {
            // 修改产品的逻辑（自定义事件名，小写或-连接，不能小驼峰命名）
            // this.$emit('edit-good', { ...this.ruleForm, good_img: this.selectedFile, flag: this.flag });
            _this3.editGood(_objectSpread(_objectSpread({}, _this3.ruleForm), {}, {
              good_img: _this3.selectedFile,
              flag: _this3.flag
            }));
          } else {
            // 添加产品的逻辑
            // 整理参数，将shop_name属性排除，上架状态传递中文，默认是待审核
            // const { shop_name, ...rest } = this.ruleForm;
            // const data = Object.assign({}, rest)
            _this3.addGood(_objectSpread(_objectSpread({}, _this3.ruleForm), {}, {
              good_img: _this3.selectedFile
            }));
          }
        } else {
          alert('提交失败!!');
          return false;
        }
      });
    },
    // 取消重置按钮——done
    resetForm: function resetForm(formName) {
      if (this.isEdit) {
        // 通知父组件取消按钮被点击
        this.$emit('cancel');
        // 清空输入的数据
        this.$refs[formName].resetFields();
        // 重新获取数据
        this.getList();
      } else {
        // 通知父组件取消按钮被点击
        this.$emit('cancel');
        // 清空输入的数据
        this.$refs[formName].resetFields();
      }
    },
    // 产品分类——done
    handleChange: function handleChange() {
      //  一级分类
      this.ruleForm.main_class = this.optionsvalue[0];
      // // // 二级分类
      this.ruleForm.sub_class = this.optionsvalue[1];
    },
    // 上架状态——done
    activeChange: function activeChange(val) {
      if (val === 0) {
        this.activeZH = '下架';
      } else {
        this.activeZH = '上架';
      }
    },
    // 根据id获取产品详情——done
    setBindMobile: function setBindMobile() {
      var _this4 = this;
      this.listLoading = true;
      if (this.bind_mobile) {
        (0, _request.default)({
          url: "/system/goods/bindMobile/",
          method: 'put',
          data: {
            goods_id: this.pk,
            mobile: this.bind_mobile
          }
        }).then(function (response) {
          console.log(response);
          if (response.code == 200) {
            _this4.dialogFormVisible1 = false;
            //   this.dialogFormVisible2=true
            _this4.$message({
              dangerouslyUseHTMLString: true,
              message: '<img style="width:200px;height:200px" src="' + _this4.qrImg + '"></img>',
              duration: 0,
              showClose: true
            });
          } else {
            _this4.$message.error(response.msg);
          }
          // window.location.reload();
        });
      } else {
        this.$message.error('会员手机号不可为空');
      }
    },
    getList: function getList() {
      var _this5 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/Goods/".concat(this.pk, "/"),
        method: 'get',
        params: {
          shop: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          // 保存数据
          _this5.ruleForm = response.data;
          // 处理数据格式
          // this.ruleForm.active = response.data.active === "下架" ? 0 : 1;
          _this5.ruleForm.brand = response.data.brand === "自有品牌" ? "" : response.data.brand;
          _this5.ruleForm.model = response.data.model === "无" ? "" : response.data.model;

          // 后端返回的是数组，必须转换成字符串
          // this.ruleForm.cost_rule = this.costRule
          _this5.moneyStringtoArray();

          // 如果不是拒绝就改变
          if (_this5.ruleForm.active != '拒绝') {
            _this5.is_checkbill = true;
          }

          //
          _this5.optionsvalue = [_this5.ruleForm.main_class, _this5.ruleForm.sub_class];
        }
        _this5.listLoading = false;
      });

      // 请求图片
      (0, _request.default)({
        url: "/system/goods/goods_image_get/?goods_id=".concat(this.pk),
        method: 'get'
      }).then(function (response) {
        // 保存为base64格式
        _this5.imageUrl = "data:image/png;base64,".concat(response.data);
        _this5.selectedFile = _this5.imageUrl;
      });
    },
    moneyStringtoArrayQ: function moneyStringtoArrayQ() {
      // this.newRuledata=[]
      this.checkRule();
      this.moneyStringtoArray();
      // this.generateTotal(this.newRuledata);
      // this.computedRule();
      // this.newRuledata.sort((a, b) => a.date.localeCompare(b.date));
    },
    checkRule: function checkRule() {
      //   console.log(this.ruleForm.cost_rule)
      var cost_rule = this.ruleForm.cost_rule;
      if (cost_rule) {
        var arr = cost_rule.split(',');
        if (arr.length >= 45) {
          var min = 10000;
          var max = 0;
          arr.map(function (item, index) {
            if (item < min) {
              min = item;
            }
            if (item > max) {
              max = item;
            }
            // console.log(item)
          });
          //   console.log(min)
          //   console.log(max)
        } else {
          this.$message.error('总期数小于45天');
        }
      } else {
        this.$message.error('扣款规则未设置');
      }
    },
    moneyStringtoArray: function moneyStringtoArray() {
      var _this6 = this;
      // 将返回的字符串转换成数组，放到newRuledata中

      var arr = this.ruleForm.cost_rule.split(',');
      var newRuledata2 = [];
      // console.log(this.ruleForm.cost_rule)
      // console.log(arr)
      // 获取当前日期，这块需要做的处理比较多，和当时生成预览账单得逻辑要反过来
      arr.map(function (item, index) {
        // console.log(item)
        // 在当前日期基础上加index天，输出格式 年月日  2025年3月28日这种
        var nowdate = new Date();
        var arrdate = new Date(nowdate);
        arrdate.setDate(nowdate.getDate() + index);
        var regex = /^\d{4}-\d{2}-\d{2}$/;
        if (!regex.test(arrdate)) {
          arrdate = _this6.formatDatefn(arrdate);
        }
        if (item.includes('|')) {
          var miniarrr = [];
          var minimoney = 0;
          item.split('|').map(function (item1, index1) {
            minimoney += parseFloat(item1);

            // item1遍历生成一个数组 每个项包含date和money 然后放到item的splitmoney属性里
            miniarrr.push({
              // date: this.formatDatefn(arrdate),
              date: arrdate,
              money: item1
            });
          });
          newRuledata2.push({
            record: index,
            money: minimoney,
            // 金额直接用第一期的金额
            date: arrdate,
            splitmoney: miniarrr,
            splitnum: item.split('|').length,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: false,
            // 允许拆单
            isSplitVisibel: true
          });
        } else {
          newRuledata2.push({
            record: index,
            money: item,
            // 金额直接用第一期的金额
            date: arrdate,
            splitmoney: [],
            splitnum: 0,
            tempSplitnum: null,
            // 添加 tempSplitnum 属性
            is_split: false,
            // 允许拆单
            isSplitVisibel: false
          });
        }
      });

      // // 将0的过滤掉
      newRuledata2 = newRuledata2.filter(function (item) {
        return item.money != 0;
      });
      this.newRuledata = newRuledata2;
      // console.log(this.newRuledata)
    },
    handleClick: function handleClick() {
      //   console.log(this.ruleForm)
    },
    validateAmountAndDate: function validateAmountAndDate(data, isshow) {
      this.errorarr = [];
      var errors = [];
      var isValid = true;
      // 1.将所有子账单相加是否等于当期扣款金额
      data.forEach(function (item) {
        if (item.splitmoney.length > 0) {
          var onemoney = 0; // 每次循环时重置 onemoney
          item.splitmoney.forEach(function (item1) {
            onemoney += parseFloat(item1.money || 0);
          });
          if (onemoney !== parseFloat(item.money || 0)) {
            errors.push("\u9884\u89C8\u8D26\u5355\u4E2D\u7684".concat(item.date, "\u7684\u6263\u6B3E\u91D1\u989D\u548C\u62C6\u5355\u6263\u6B3E\u91D1\u989D\u603B\u548C\u4E0D\u4E00\u81F4"));
            isValid = false;
          }
        }
      });

      // 子帐单的扣款日期要和主账单一致
      data.forEach(function (item) {
        if (item.splitmoney.length > 0) {
          if (item.date !== item.splitmoney[0].date) {
            errors.push("\u7B2C".concat(item.record, "\u671F\u7684\u6263\u6B3E\u65E5\u671F\u548C\u62C6\u5355\u6263\u6B3E\u65E5\u671F\u4E0D\u4E00\u81F4"));
            isValid = false;
          }
        }
      });

      // 扣款金额必须大于0
      data.forEach(function (item) {
        if (item.money <= 0) {
          errors.push("\u7B2C".concat(item.record, "\u671F\u7684\u6263\u6B3E\u91D1\u989D\u5FC5\u987B\u5927\u4E8E0"));
          isValid = false;
        }
      });

      // 1.计算总金额与首付扣款总额
      var totalAmount = 0;
      data.forEach(function (item) {
        totalAmount += parseFloat(item.money || 0);
      });

      // 比较总金额与首付扣款总额
      if (totalAmount > parseFloat(this.ruleForm.shou_money || 0)) {
        errors.push('预览账单中的扣款金额总和不能超过首付扣款总额');
        isValid = false;
      } else if (totalAmount < parseFloat(this.ruleForm.shou_money || 0)) {
        errors.push('预览账单中的扣款金额总和小于首付扣款总额');
        isValid = false;
      }

      // 2.校验日期，日期必须递增，不能有相等的情况存在
      for (var i = 0; i < data.length - 1; i++) {
        if (new Date(data[i].date) >= new Date(data[i + 1].date)) {
          errors.push("\u9884\u89C8\u8D26\u5355\u4E2D\u7684\u7B2C".concat(i + 2, " \u671F\u6263\u6B3E\u65E5\u671F\u5FC5\u987B\u9012\u589E\uFF01"));
          isValid = false;
        }
      }

      // 如果有错误，显示所有错误信息
      if (errors.length > 0 && isshow == true) {
        // this.$message.error({
        //   message: errors.join('\n'),
        //   duration: 5000 // 设置为5秒，可以根据需要调整
        // });

        this.errorarr = errors;
      }
      return isValid;
    },
    // 定义一个函数，用于将日期对象转换为 YYYY-MM-DD 格式
    formatDatefn: function formatDatefn(date) {
      console.log(date);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      console.log("".concat(year, "-").concat(month, "-").concat(day));
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    // 新增商品
    addGood: function addGood(val) {
      var _this7 = this;
      delete val.shop_name;
      // 1.加载中
      this.listLoading = true;
      // 2.发送请求，添加产品
      (0, _request.default)({
        url: "/Goods/",
        method: 'post',
        params: {
          shop: this.$user.data.shop
        },
        // url参数
        data: _objectSpread(_objectSpread({}, val), {}, {
          active: '待审核',
          goods_cate: val.goods_cate || 3,
          parameter: val.parameter || '无',
          parameter_value: val.parameter_value || '无',
          shop: this.$user.data.shop,
          // 以下为新增字段
          brand: val.brand || '自有品牌',
          model: val.model || '无',
          main_class: val.main_class || 'GENERAL',
          sub_class: val.sub_class || 'general_other'
        }) // 请求体参数
      }).then(function (response) {
        if (!response) {
          _this7.$message.error('创建异常，请检查商品名');
          _this7.listLoading = false;
          return;
        }
        if (response.code == 200 || 201) {
          // 将图片上传到服务器
          if (val.good_img) {
            var formData = new FormData();
            formData.append('file', val.good_img);
            formData.append('goods_id', response.data.id);
            (0, _request.default)({
              url: "/system/goods/goods_file_up/",
              method: 'post',
              data: formData
            }).then(function (res) {
              if (res.code === 200) {
                console.log('图片上传成功');
              } else {
                console.log('图片上传失败');
              }
            }).catch(function (err) {
              console.log(err, '图片上传失败');
            });
            // 3.提示添加成功
            _this7.$message({
              message: "\u6DFB\u52A0\u6210\u529F",
              type: 'success'
            });

            // 关闭loading
            _this7.listLoading = false;
            // 4.关闭新增产品form
            _this7.dialogFormVisible = false;
            // this.reload()
            setTimeout(function () {
              // 返回列表
              _this7.$router.push({
                name: 'goodList'
              });
            }, 500);
          } else {
            // 3.提示添加成功
            _this7.$message({
              message: "\u6DFB\u52A0\u6210\u529F",
              type: 'success'
            });
            // 关闭loading
            _this7.listLoading = false;
            setTimeout(function () {
              // 返回列表
              _this7.$router.push({
                name: 'goodList'
              });
            }, 500);
          }
        }
      }).catch(function (err) {
        console.log(err, '新增失败');
      });
    },
    // 修改产品
    editGood: function editGood(val) {
      var _this8 = this;
      this.listLoading = true;
      // 2.发送请求添加产品
      (0, _request.default)({
        url: "/Goods/".concat(this.pk, "/"),
        method: 'put',
        params: {
          shop: this.$user.data.shop
        },
        data: {
          name: val.name,
          cost_type: val.cost_type,
          day_num: val.day_num,
          order_mode: val.order_mode,
          //   active: val.active,
          active: val.active == '拒绝' ? '待审核' : val.active == '0' ? '下架' : val.active == '1' ? '上架' : val.active,
          cost_money: val.cost_money,
          deposit: val.deposit,
          order_type: val.order_type,
          money: val.money,
          goods_cate: val.goods_cate || 3,
          cost_num: val.cost_num,
          cost_rule: val.cost_rule,
          q_cost_day: val.q_cost_day,
          d_cost_type: val.d_cost_type,
          d_cost_money: val.d_cost_money,
          remark: val.remark,
          parameter: val.parameter || '无',
          parameter_value: val.parameter_value || '无',
          shop: this.$user.data.shop,
          // 以下为新增字段
          brand: val.brand || '自有品牌',
          model: val.model || '无',
          // 需要传递默认值
          main_class: val.main_class || GENERAL,
          sub_class: val.sub_class || general_other,
          // good_img:val.good_img
          shou_money: val.shou_money,
          shou_cost_num: val.shou_cost_num,
          shou_cost_day: val.shou_cost_day
        }
      }).then(function (res) {
        if (!res) {
          _this8.$message.error('修改异常，请检查商品名');
          _this8.listLoading = false;
          return;
        }
        if (res.code === 200 || 201) {
          // 图片更新时进行上传
          console.log(val.flag, "flag");
          if (val.flag != false) {
            var formData = new FormData();
            formData.append('file', val.good_img);
            formData.append('goods_id', _this8.pk);
            (0, _request.default)({
              url: "/system/goods/goods_file_up/",
              method: 'post',
              data: formData
            }).then(function (res) {
              if (res.code === 200) {
                // 获取图片进行展示
                (0, _request.default)({
                  url: "/system/goods/goods_image_get/?goods_id=".concat(_this8.pk),
                  method: 'get'
                }).then(function (res) {
                  // 保存为base64格式
                  _this8.good_img = "data:image/png;base64,".concat(res.data);
                });
              } else {
                console.log('图片上传失败');
              }
            }).catch(function (err) {
              console.log(err, '图片上传失败');
            });
          } else {
            console.log("不上传图片");
          }
          // 1.提示添加成功
          _this8.$message({
            message: "\u4FEE\u6539\u6210\u529F",
            type: 'success'
          });
          setTimeout(function () {
            // 返回列表
            _this8.$router.push({
              name: 'goodList'
            });
          }, 500);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkGoodState: function checkGoodState(event, item, index) {
      if (this.ruleForm.active != '拒绝') {
        this.$message.error('当前商品处于非拒绝状态，不可修改');
        // 恢复原始值
        var originalDate = this.newRuledata[index].date;
        this.$nextTick(function () {
          item.date = originalDate;
        });
        return;
      }
    },
    checkDate: function checkDate() {
      var _this9 = this;
      var is_ok = true;
      this.newRuledata.forEach(function (item) {
        if (item.date == _this9.split_date) {
          is_ok = false;
        }
      });
      return is_ok;
    },
    deleteItem: function deleteItem(data) {
      //删除划扣
      var newRuledata3 = [];
      this.newRuledata.forEach(function (item) {
        if (item.date != data.date) {
          newRuledata3.push(item);
        }
      });
      this.newRuledata = newRuledata3;

      //   console.log(this.newRuledata)
      // this.generateTotal(this.newRuledata);
      // this.computedRule(this.newRuledata);
    },
    arrByDate: function arrByDate() {
      this.newRuledata.sort(function (a, b) {
        return a.date.localeCompare(b.date);
      });
      // console.log(date)
    },
    clossPop: function clossPop() {
      if (this.split_money <= 0) {
        this.$message.error('划扣金额不可小于等于0');
        return;
      }
      if (this.checkDate()) {
        //添加新设置的期数

        this.newRuledata.push({
          record: this.newRuledata.length + 1,
          money: this.split_money,
          // 金额直接用第一期的金额
          date: this.split_date,
          splitmoney: [],
          splitnum: 0,
          tempSplitnum: null,
          // 添加 tempSplitnum 属性
          is_split: false,
          // 允许拆单
          isSplitVisibel: true
        });

        // console.log(this.newRuledata)
        this.dialogFormVisible = false;
        this.newRuledata.sort(function (a, b) {
          return a.date.localeCompare(b.date);
        });
        // this.computedRule();

        // if (!this.validateAmountAndDate(this.newRuledata, true)) {

        //   return; // 如果验证失败，直接返回，不继续执行
        // }else{
        //   this.generateTotal(this.newRuledata);
        //   this.computedRule(this.newRuledata);
        // }
      } else {
        this.$message.error('该日期已存在不可添加');
      }
    }
  }
};